import { Splide } from '@splidejs/splide';
import '@splidejs/splide/css';

const sliders = {
  init() {
    this.heroSlider();
    this.prodSlider();
    this.uspSlider();

  },

  resetSlider() {
    window.addEventListener('reset', () => {});
  },



  uspSlider() {
    const sliders = document.querySelectorAll(
      '.jsUspSlider',
    ) as NodeListOf<HTMLElement>;

    sliders.forEach((item) => {
      new Splide(item, {
        type: 'loop',
        pagination: false,
        arrows: false,
        autoplay: true,
        speed: 800,
        perPage: 3,
        destroy: true,
        breakpoints: {
          1200: {
            perPage: 1,
            destroy: false, 

          }
        },
      }).mount();
    });
  },


  heroSlider() {
    const heroSliders = document.querySelectorAll(
      '.jsHeroSlider',
    ) as NodeListOf<HTMLElement>;
    heroSliders.forEach((el) => {
      const slider = new Splide(el, {
        type: 'loop',
        perPage: 1,
        pagination: true,
        arrows: true,
        autoplay: true,
        speed: 800,
      });

      slider.on('pagination:mounted', function (data) {
        data.list.classList.add('splide__pagination--custom');
        data.items.forEach(function (item) {
          item.button.innerHTML = `<span>0${item.page + 1}</span>`;
        });
      });
      slider.mount();
    });
  },


  prodSlider() {
    const sliders = document.querySelectorAll(
      '.jsProdSlider',
    ) as NodeListOf<HTMLElement>;

    sliders.forEach((item) => {
      new Splide(item, {
        type: 'loop',
        pagination: false,
        arrows: true,
        autoplay: true,
        speed: 800,
        gap: 18,
        perPage: 5,
        breakpoints: {
          768: {
            perPage: 3,
          },
          460: {
            perPage: 1,
            padding: { right: '30%' },
          },
        },
      }).mount();
    });
  },
};

export default sliders;
